/**
 * Shared URL-search shape for the nabídky / smlouvy / výkup list + detail
 * routes (vozidla and ojetá-vozidla modules). Persisting the filters in the
 * URL means the narrow rail on the detail page matches the filter the user
 * had on the list page (and bookmarks / back-forward navigation work as
 * expected) — the same pattern as `VozidlaSearch` (modules/vozidla/helpers.ts)
 * and `KontaktySearch` (modules/kontakty/filters.ts).
 */

export interface NabidkySmlouvySearch {
  /** Free-text client-name filter (`hledanejmeno` on the API). */
  search?: string;
  /** Document-number filter (`cislo_nabidky` / `cislo_smlouvy` on the API). */
  cislo?: string;
}

/**
 * URL search values arrive JSON-typed from the router (a hand-typed deep link
 * `?cislo=77` parses to the number 77; the app's own links write the quoted
 * string form) — accept both and normalize to the string the API expects.
 */
export function searchParamString(v: unknown): string | undefined {
  if (typeof v === 'string' && v.length > 0) return v;
  if (typeof v === 'number' && Number.isFinite(v)) return String(v);
  return undefined;
}

/** TanStack Router `validateSearch` — coerces unknown query strings into
 *  the typed shape, dropping anything we don't recognize. */
export function parseNabidkySmlouvySearch(
  input: Record<string, unknown>,
): NabidkySmlouvySearch {
  const out: NabidkySmlouvySearch = {};
  const search = searchParamString(input.search);
  if (search) out.search = search;
  const cislo = searchParamString(input.cislo);
  if (cislo) out.cislo = cislo;
  return out;
}
